"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePositionInternal = calculatePositionInternal;
exports["default"] = calculatePosition;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _style = _interopRequireDefault(require("dom-helpers/style"));

var _offset = _interopRequireDefault(require("dom-helpers/query/offset"));

var _position = _interopRequireDefault(require("dom-helpers/query/position"));

var _scrollLeft = _interopRequireDefault(require("dom-helpers/query/scrollLeft"));

var _scrollTop = _interopRequireDefault(require("dom-helpers/query/scrollTop"));

var _ownerDocument = _interopRequireDefault(require("dom-helpers/ownerDocument"));

var _reactDom = _interopRequireDefault(require("react-dom"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var AXIS = {
  top: 'top',
  bottom: 'top',
  left: 'left',
  right: 'left',
  center: 'left'
};
var FLIPPED_DIRECTION = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
var CROSS_AXIS = {
  top: 'left',
  left: 'top'
};
var AXIS_SIZE = {
  top: 'height',
  left: 'width'
};
var PARSED_PLACEMENT_CACHE = {};

function getContainerDimensions(containerNode) {
  var width,
      height,
      top = 0,
      left = 0;
  var scroll = {};

  var containerDOMNode = _reactDom["default"].findDOMNode(containerNode);

  if (containerDOMNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;
    scroll.top = (0, _scrollTop["default"])((0, _ownerDocument["default"])(containerDOMNode).documentElement) || (0, _scrollTop["default"])(containerDOMNode);
    scroll.left = (0, _scrollLeft["default"])((0, _ownerDocument["default"])(containerDOMNode).documentElement) || (0, _scrollLeft["default"])(containerDOMNode);
  } else {
    var _getOffset = (0, _offset["default"])(containerDOMNode);

    width = _getOffset.width;
    height = _getOffset.height;
    top = _getOffset.top;
    left = _getOffset.left;
    scroll.top = (0, _scrollTop["default"])(containerDOMNode);
    scroll.left = (0, _scrollLeft["default"])(containerDOMNode);
  }

  return {
    width: width,
    height: height,
    scroll: scroll,
    top: top,
    left: left
  };
}

function getDelta(axis, offset, size, containerDimensions, padding) {
  var containerScroll = containerDimensions.scroll[axis];
  var containerHeight = containerDimensions[AXIS_SIZE[axis]];
  var startEdgeOffset = offset - padding - containerScroll;
  var endEdgeOffset = offset + padding - containerScroll + size;

  if (startEdgeOffset < 0) {
    return -startEdgeOffset;
  } else if (endEdgeOffset > containerHeight) {
    return Math.max(containerHeight - endEdgeOffset, -startEdgeOffset);
  } else {
    return 0;
  }
}

function shouldFlip(axis, offset, size, padding, placement, flipContainerDimensions, containerOffsetWithBoundary) {
  var containerScroll = flipContainerDimensions.scroll[axis];
  var containerHeight = flipContainerDimensions[AXIS_SIZE[axis]];
  var startEdgeOffset = containerOffsetWithBoundary[axis] + offset - padding - containerScroll;
  var endEdgeOffset = containerOffsetWithBoundary[axis] + offset + padding - containerScroll + size;

  if (startEdgeOffset < 0 && (placement === 'top' || placement === 'left')) {
    return true;
  } else if (endEdgeOffset > containerHeight && (placement === 'bottom' || placement === 'right')) {
    return true;
  } else {
    return false;
  }
}

function getMargins(node) {
  var style = window.getComputedStyle(node);
  return {
    top: parseInt(style.marginTop, 10) || 0,
    bottom: parseInt(style.marginBottom, 10) || 0,
    left: parseInt(style.marginLeft, 10) || 0,
    right: parseInt(style.marginRight, 10) || 0
  };
}

function parsePlacement(input) {
  if (PARSED_PLACEMENT_CACHE[input]) {
    return PARSED_PLACEMENT_CACHE[input];
  }

  var _input$split = input.split(' '),
      _input$split2 = (0, _slicedToArray2["default"])(_input$split, 2),
      placement = _input$split2[0],
      crossPlacement = _input$split2[1];

  var axis = AXIS[placement] || 'right';
  var crossAxis = CROSS_AXIS[axis];

  if (!AXIS[crossPlacement]) {
    crossPlacement = 'center';
  }

  var size = AXIS_SIZE[axis];
  var crossSize = AXIS_SIZE[crossAxis];
  PARSED_PLACEMENT_CACHE[input] = {
    placement: placement,
    crossPlacement: crossPlacement,
    axis: axis,
    crossAxis: crossAxis,
    size: size,
    crossSize: crossSize
  };
  return PARSED_PLACEMENT_CACHE[input];
}

function computePosition(childOffset, containerDimensions, overlaySize, placementInfo, offset, crossOffset) {
  var placement = placementInfo.placement,
      crossPlacement = placementInfo.crossPlacement,
      axis = placementInfo.axis,
      crossAxis = placementInfo.crossAxis,
      size = placementInfo.size,
      crossSize = placementInfo.crossSize;
  var position = {};
  position[crossAxis] = childOffset[crossAxis] + crossOffset;

  if (crossPlacement === 'center') {
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
  } else if (crossPlacement !== crossAxis) {
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
  } // Ensure overlay sticks to target(ignore for overlays smaller than target)


  if (childOffset[crossSize] < overlaySize[crossSize]) {
    var positionForPositiveSideOverflow = Math.min(position[crossAxis], childOffset[crossAxis]);
    position[crossAxis] = Math.max(positionForPositiveSideOverflow, childOffset[crossAxis] - overlaySize[crossSize] + childOffset[crossSize]);
  }

  if (placement === axis) {
    position[axis] = childOffset[axis] - overlaySize[size] + offset;
  } else {
    position[axis] = childOffset[axis] + childOffset[size] + offset;
  }

  return position;
}

function calculatePositionInternal(placementInput, containerDimensions, childOffset, overlaySize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset) {
  var placementInfo = parsePlacement(placementInput);
  var _placementInfo = placementInfo,
      axis = _placementInfo.axis,
      size = _placementInfo.size,
      crossAxis = _placementInfo.crossAxis,
      crossSize = _placementInfo.crossSize,
      placement = _placementInfo.placement,
      crossPlacement = _placementInfo.crossPlacement;
  var position = computePosition(childOffset, containerDimensions, overlaySize, placementInfo, offset, crossOffset);
  var normalizedOffset = offset; // First check if placement should be flipped

  if (flip && shouldFlip(axis, position[axis], overlaySize[size], padding, placement, boundaryDimensions, containerOffsetWithBoundary)) {
    var flippedPlacementInfo = parsePlacement("".concat(FLIPPED_DIRECTION[placement], " ").concat(crossPlacement));
    var _axis = flippedPlacementInfo.axis,
        _size = flippedPlacementInfo.size;
    var flippedPosition = computePosition(childOffset, containerDimensions, overlaySize, flippedPlacementInfo, -1 * offset, crossOffset); // Check if flipped placement has enough space otherwise flip is not possible

    if (!shouldFlip(_axis, flippedPosition[_axis], overlaySize[_size], padding, FLIPPED_DIRECTION[placement], boundaryDimensions, containerOffsetWithBoundary)) {
      placementInfo = flippedPlacementInfo;
      position = flippedPosition;
      normalizedOffset = -1 * offset;
    }
  }

  var delta = getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
  position[crossAxis] += delta;
  var maxHeight = Math.max(0, boundaryDimensions.height + boundaryDimensions.top + boundaryDimensions.scroll.top - containerOffsetWithBoundary.top - position.top - margins.top - margins.bottom - padding);
  overlaySize.height = Math.min(overlaySize.height, maxHeight);
  position = computePosition(childOffset, containerDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset);
  delta = delta = getDelta(crossAxis, position[crossAxis], overlaySize[crossSize], boundaryDimensions, padding);
  position[crossAxis] += delta;
  var arrowPosition = {};
  arrowPosition[crossAxis] = childOffset[crossSize] > overlaySize[crossSize] ? null : childOffset[crossAxis] - position[crossAxis] + childOffset[crossSize] / 2;
  return {
    positionLeft: position.left,
    positionTop: position.top,
    maxHeight: maxHeight,
    arrowOffsetLeft: arrowPosition.left,
    arrowOffsetTop: arrowPosition.top,
    placement: placementInfo.placement
  };
}

function calculatePosition(placementInput, overlayNode, target, container, padding, flip, boundariesElement, offset, crossOffset) {
  var isBodyContainer = container.tagName === 'BODY';
  var childOffset = isBodyContainer ? (0, _offset["default"])(target) : (0, _position["default"])(target, container);

  if (!isBodyContainer) {
    childOffset.top += parseInt((0, _style["default"])(target, 'marginTop'), 10) || 0;
    childOffset.left += parseInt((0, _style["default"])(target, 'marginLeft'), 10) || 0;
  }

  var overlaySize = (0, _offset["default"])(overlayNode);
  var margins = getMargins(overlayNode);
  overlaySize.width += margins.left + margins.right;
  overlaySize.height += margins.top + margins.bottom;
  var containerDimensions = getContainerDimensions(container);
  var boundaryContainer = boundariesElement === 'container' ? container : boundariesElement();
  var boundaryDimensions = getContainerDimensions(boundaryContainer);
  var containerOffsetWithBoundary = boundaryContainer.tagName === 'BODY' ? (0, _offset["default"])(container) : (0, _position["default"])(container, boundaryContainer);
  return calculatePositionInternal(placementInput, containerDimensions, childOffset, overlaySize, margins, padding, flip, boundaryDimensions, containerOffsetWithBoundary, offset, crossOffset);
}